import React, { useEffect, useState } from "react";
import { Row, Input } from "reactstrap";
import {
  useBasinFindAllQuery,
  useAu1FindAllQuery,
  useAu2FindAllQuery,
  useAu3FindAllQuery,
} from "store";

interface Props {
  formik: any;
  showBasin?: boolean;
  showAu1?: boolean;
  showAu2?: boolean;
  showAu3?: boolean;
}

const AuInputList: React.FC<Props> = ({
  formik,
  showBasin = true,
  showAu1 = true,
  showAu2 = true,
  showAu3 = true,
}) => {
  const { values, setFieldValue } = formik;

  const [au1, setAu1] = useState(values.au1_code || "");
  const [au2, setAu2] = useState(values.au2_code || "");

  /* ---------- Queries ---------- */
  const { data: basinData } = useBasinFindAllQuery();
  const { data: au1Data } = useAu1FindAllQuery();
  const { data: au2Data } = useAu2FindAllQuery(`?au1_code=${au1}`);
  const { data: au3Data } = useAu3FindAllQuery(
    `?au1_code=${au1}&au2_code=${au2}`
  );

  /* ---------- Sync with Formik initial values ---------- */
  useEffect(() => {
    setAu1(values.au1_code || "");
    setAu2(values.au2_code || "");
  }, [values.au1_code, values.au2_code]);

  return (
    <>
      {/* Basin */}
      {showBasin && (
        <div className="mb-3">
          <label className="fw-semibold">Сав газар:</label>
          <Input
            type="select"
            className="form-select"
            name="basin_code"
            value={values.basin_code || ""}
            onChange={(e) => setFieldValue("basin_code", e.target.value)}
          >
            <option value="">Сонгох</option>
            {basinData?.data?.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item.id} :: {item.basin_name}
              </option>
            ))}
          </Input>
        </div>
      )}

      {/* AU1 */}
      {showAu1 && (
        <div className="mb-3">
          <label className="fw-semibold">Аймаг / Нийслэл:</label>
          <Input
            type="select"
            className="form-select"
            value={au1}
            onChange={(e) => {
              const val = e.target.value;
              setAu1(val);
              setFieldValue("au1_code", val);
              setFieldValue("au2_code", "");
              setFieldValue("au3_code", "");
              setAu2("");
            }}
          >
            <option value="">Сонгох</option>
            {au1Data?.data?.map((item: any) => (
              <option key={item.code} value={item.code}>
                {item.code} :: {item.name}
              </option>
            ))}
          </Input>
        </div>
      )}

      {/* AU2 */}
      {showAu2 && (
        <div className="mb-3">
          <label className="fw-semibold">Сум / Дүүрэг:</label>
          <Input
            type="select"
            className="form-select"
            value={au2}
            onChange={(e) => {
              const val = e.target.value;
              setAu2(val);
              setFieldValue("au2_code", val);
              setFieldValue("au3_code", "");
            }}
            disabled={!au1}
          >
            <option value="">Сонгох</option>
            {au2Data?.data?.map((item: any) => (
              <option key={item.code} value={item.code}>
                {item.code} :: {item.name}
              </option>
            ))}
          </Input>
        </div>
      )}

      {/* AU3 */}
      {showAu3 && (
        <div className="mb-3">
          <label className="fw-semibold">Баг / Хороо:</label>
          <Input
            type="select"
            className="form-select"
            name="au3_code"
            value={values.au3_code || ""}
            onChange={(e) => setFieldValue("au3_code", e.target.value)}
            disabled={!au2}
          >
            <option value="">Сонгох</option>
            {au3Data?.data?.map((item: any) => (
              <option key={item.code} value={item.code}>
                {item.code} :: {item.name}
              </option>
            ))}
          </Input>
        </div>
      )}
    </>
  );
};

export default AuInputList;